import { NgModule } from '@angular/core';
import { WebSidebarComponent } from './web-sidebar/web-sidebar';
@NgModule({
	declarations: [WebSidebarComponent],
	imports: [],
	exports: [WebSidebarComponent]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts